/**
 * Challenge card header – timer rows and started state.
 * Composed by challengeCardHeader.styles.ts.
 */

import { Platform } from 'react-native';
import { makeBoxShadow } from '../../shared/helpers/shadowStyles.helper';
import type { Theme } from '../../theme/getTheme';

export function getChallengeCardHeaderTimerStyles(theme: Theme, narrow: boolean) {
  return {
    homeTimerInline: {
      flexDirection: 'row' as const,
      alignItems: 'center' as const,
      justifyContent: 'center' as const,
      gap: narrow ? 0 : 1,
      paddingVertical: narrow ? 2 : 4,
      paddingHorizontal: narrow ? 4 : 8,
      borderRadius: narrow ? 6 : 10,
      backgroundColor: theme.timerInsetBg,
      borderWidth: 0,
      ...(Platform.OS === 'web'
        ? makeBoxShadow({
            shadowColor: theme.accentDark,
            shadowOffset: { width: 0, height: 0 },
            shadowOpacity: 0.12,
            shadowRadius: 6,
          })
        : {
            shadowColor: theme.accentDark,
            shadowOffset: { width: 0, height: 0 },
            shadowOpacity: 0.12,
            shadowRadius: 6,
            elevation: 2,
          }),
    },
    homeTimerInlineUrgent: {
      borderWidth: 1,
      borderColor: `${theme.error}80`,
    },
    homeTimerRow: {
      flexDirection: 'row' as const,
      alignItems: 'center' as const,
      justifyContent: 'center' as const,
      alignSelf: 'stretch' as const,
      gap: narrow ? 1 : 2,
      marginTop: 6,
      minHeight: narrow ? 36 : 40,
      paddingVertical: 8,
      paddingHorizontal: narrow ? 8 : 12,
      borderRadius: 14,
      backgroundColor: theme.timerInsetBg,
      borderWidth: 0,
      borderColor: 'transparent',
      ...(Platform.OS === 'web'
        ? makeBoxShadow({
            shadowColor: theme.accentDark,
            shadowOffset: { width: 0, height: 0 },
            shadowOpacity: 0.12,
            shadowRadius: 8,
          })
        : {
            shadowColor: theme.accentDark,
            shadowOffset: { width: 0, height: 0 },
            shadowOpacity: 0.12,
            shadowRadius: 8,
            elevation: 2,
          }),
    },
    homeTimerRowUrgent: {
      flexDirection: 'row' as const,
      alignItems: 'center' as const,
      justifyContent: 'center' as const,
      alignSelf: 'stretch' as const,
      gap: narrow ? 1 : 2,
      marginTop: 6,
      minHeight: narrow ? 36 : 40,
      paddingVertical: 8,
      paddingHorizontal: narrow ? 8 : 12,
      borderRadius: 14,
      backgroundColor: theme.timerInsetBg,
      borderWidth: 0,
      borderColor: 'transparent',
      ...(Platform.OS === 'web'
        ? makeBoxShadow({
            shadowColor: theme.error,
            shadowOffset: { width: 0, height: 0 },
            shadowOpacity: 0.18,
            shadowRadius: 8,
          })
        : {
            shadowColor: theme.error,
            shadowOffset: { width: 0, height: 0 },
            shadowOpacity: 0.18,
            shadowRadius: 8,
            elevation: 2,
          }),
    },
    homeTimerSegment: {
      alignItems: 'center' as const,
      justifyContent: 'center' as const,
      minWidth: narrow ? 20 : 36,
    },
    homeTimerNumber: {
      fontSize: narrow ? 11 : 16,
      fontWeight: '800',
      letterSpacing: 1,
      color: theme.accentDark,
      fontFamily: Platform.OS === 'ios' ? 'Menlo' : 'monospace',
    },
    homeTimerNumberUrgent: {
      fontSize: narrow ? 11 : 16,
      fontWeight: '800',
      letterSpacing: 1,
      color: theme.error,
      fontFamily: Platform.OS === 'ios' ? 'Menlo' : 'monospace',
    },
    homeTimerLabel: {
      fontSize: narrow ? 6 : 8,
      marginTop: 1,
      color: theme.timerLabelColor,
      textTransform: 'lowercase' as const,
    },
    homeTimerColon: {
      fontSize: narrow ? 9 : 14,
      fontWeight: '800',
      color: theme.accentDark + '99',
      fontFamily: Platform.OS === 'ios' ? 'Menlo' : 'monospace',
      alignSelf: 'flex-end' as const,
      marginBottom: narrow ? 4 : 9,
    },
    homeTimerStartedRow: {
      flexDirection: 'row' as const,
      alignItems: 'center' as const,
      justifyContent: 'center' as const,
      alignSelf: 'stretch' as const,
      marginTop: 6,
      minHeight: narrow ? 36 : 40,
      paddingVertical: 8,
      paddingHorizontal: narrow ? 8 : 12,
      borderRadius: 14,
      backgroundColor: theme.timerInsetBg,
      borderWidth: 0,
      borderColor: 'transparent',
    },
    homeTimerStartedText: {
      fontSize: 12,
      fontWeight: '700',
      letterSpacing: 0.5,
      color: theme.timerLabelColor,
      fontFamily: Platform.OS === 'ios' ? 'Menlo' : 'monospace',
    },
  };
}
